import { CaseType } from "@teamprevent/common/model";
import * as React from "react";
import { Button } from "semantic-ui-react";
import { TaskTypes } from "@teamprevent/common/task/taskActions/models";

import { toast } from "@teamprevent/common/toasts";

import { PartialOhCaseDetailModel } from "../../model";

import { ADMIN_ROLES, Authorize } from "../../../../auth";

import { DeleteReferralFormModal } from "./DeleteReferralFormModal";

interface Props {
    ohCase: PartialOhCaseDetailModel;
    customerId: string;
}

const employeeCompletePpqTask = "EmployeeCompletePpqFormTask";

export const ViewCaseFormButtons = (props: Props) => {
    const referralFormDeleted = () => props?.ohCase?.tasks?.some(task =>
        task.completed && task.type === TaskTypes.SystemAdminRemovedReferralFormTask) === true;

    const toastFormDeleted = () => toast.error("This form has been removed by a System Admin user");

    return (
        <>
            {props.ohCase.caseType && props.ohCase.caseType === CaseType.IMMUNISATION &&
                <a href={`/customers/${props.customerId}/employeeRecords/${props.ohCase.employeeRecordId}/immunisations`}>
                    <Button content="View Imms Record" />
                </a>
            }
            {props.ohCase.caseType === CaseType.REFERRAL &&
             <>
                 { referralFormDeleted() &&
                    <>
                        <Button content="View Referral Form" onClick={toastFormDeleted} />
                    </>
                 }
                 { !referralFormDeleted() &&
                    <>
                        <a
                            href={`/customer/${props.customerId}/case/${props.ohCase.id}/referral`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button content="View Referral Form" />
                        </a>
                    </>
                 }
             </>
            }
            {props.ohCase.caseType === CaseType.PHYSIOTHERAPY_REFERRAL &&
                <a
                    href={`/customer/${props.customerId}/case/${props.ohCase.id}/physiotherapyreferral`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Button content="View Referral Form" />
                </a>
            }
            {props.ohCase.genericCaseType &&
                <a
                    href={`/customer/${props.customerId}/case/${props.ohCase.id}/genericCaseForm`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Button content="View Form" />
                </a>
            }
            {props.ohCase.caseType === CaseType.PPQ && props.ohCase.tasks &&
                (props.ohCase.tasks.some(t => t.type === employeeCompletePpqTask && t.completed)
                    || !props.ohCase.tasks.some(t => t.type === employeeCompletePpqTask)) &&
                <a
                    href={`/customer/${props.customerId}/case/${props.ohCase.id}/ppq`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Button content="View PPQ" />
                </a>
            }
            <a
                href={`/customers/${props.customerId}/employeeRecords/${props.ohCase.employeeRecordId}`
                    + "/clinicalHistory"}
                target="_blank"
                rel="noopener noreferrer"
            >
                <Button content="View Clinical History" />
            </a>
            {props.ohCase.caseType === CaseType.REFERRAL && !referralFormDeleted() &&
            <>
                <Authorize roles={[ADMIN_ROLES.SYSTEM_ADMIN]}>
                    <DeleteReferralFormModal customerId={props.customerId} ohCaseId={props.ohCase.id} />
                </Authorize>
            </>
            }
        </>);
};
